// Imports
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
import AccountMainView from "Modules/account/views/main"
import { HasPermission } from "Core/security";

// Router
const AccountView = (props) => {
  const user = useSelector((state) => state.securityRedux.user);
  return (
    <Routes>
      {
        HasPermission(user, "account", [24]) && (
          <Fragment>
            <Route path='/' element={<Navigate to="/app/account/main" />}></Route>
            <Route path='main' element={<AccountMainView />} />
          </Fragment>
        )
      }
      <Route path="*" element={<Navigate to="/app/error" />} />
    </Routes>
  );
};

export default AccountView;
